

export let colAttachmentName =  {
                                    colId: 'attachmentName',
                                    headerName: 'Attachment Name',
                                    field: 'name',
                                    width: 100
                                };

export let colAttachmentDescription =   {
                                            colId: 'attachmentDescription',
                                            headerName: 'Description',
                                            field: 'description',
                                            hide: false,
                                            width: 100
                                        };

export let colAttachmentCreatedDate =   {
                                            colId: 'attachmentCreateDate',
                                            headerName: 'Creation Date',
                                            field: 'createdDate',
                                            hide: false,
                                            width: 50
                                        };

export let colAttachmentDateAdded =   {
                                            colId: 'attachmentDateAdded',
                                            headerName: 'Date Added',
                                            field: 'dateAdded',
                                            hide: false,
                                            width: 50
                                        };

export let colOwner =   {
                            colId: 'owner',
                            headerName: 'Owner',
                            field: 'owner',
                            width: 100,
                            cellRenderer: ({value}) => {
                                if (value) {
                                    if (typeof value === 'string') {
                                        return value;
                                    } else {
                                        return value.email;
                                    }
                                }
                            }
                        };

export let colType =    {
                            colId: 'type',
                            headerName: 'Type',
                            field: 'attachmentType',
                            width: 100
                        };


export let colAssociatedEntityType =    {
                                            colId: 'associatedEntityType',
                                            headerName: 'Source Type',
                                            field: 'associatedEntityType',
                                            width: 100
                                        };


export let colAssociatedEntityViewValue =   {
                                                colId: 'associatedEntityViewValue',
                                                headerName: 'Source Name',
                                                field: 'associatedEntityViewValue',
                                                width: 100
                                            };


export let colAssociatedEntityId =  {
                                        colId: 'associatedEntityId',
                                        headerName: 'Source ID',
                                        field: 'associatedEntityId',
                                        width: 100
                                    };


export let colAssociatedEntityNumber =  {
                                            colId: 'associatedEntityNumber',
                                            headerName: 'Source Number',
                                            field: 'associatedEntityNumber',
                                            width: 100
                                        };


export let colFileName = {
                            colId: 'filename',
                            headerName: 'File Name',
                            field: 'originalFileName',
                            width: 50
                        };

export let colContractName =    {
                                    colId: 'contractName',
                                    headerName: 'Contract Name',
                                    field: 'contractFriendlyName',
                                    width: 100
                                };


export let allColumns = [

    colAttachmentName,
    colAttachmentDescription,
    colOwner,
    colType,
    colAssociatedEntityType,
    colAssociatedEntityViewValue,
    colAssociatedEntityId,
    colAssociatedEntityNumber,
    colAttachmentCreatedDate,
    colAttachmentDateAdded,
    colFileName,
    colContractName
]




export let columnSelectList = [
    {
        value: colAttachmentName,
        viewValue: colAttachmentName.headerName
    },
    {
        value: colAttachmentDescription,
        viewValue: colAttachmentDescription.headerName
    },
    {
        value: colOwner,
        viewValue: colOwner.headerName
    },
    {
        value: colType,
        viewValue: colType.headerName
    },
    {
        value: colFileName,
        viewValue: colFileName.headerName
    },
    {
        value: colAssociatedEntityType,
        viewValue: colAssociatedEntityType.headerName
    },
    {
        value: colAssociatedEntityViewValue,
        viewValue: colAssociatedEntityViewValue.headerName
    },
    {
        value: colAssociatedEntityId,
        viewValue: colAssociatedEntityId.headerName
    },
    {
        value: colAssociatedEntityNumber,
        viewValue: colAssociatedEntityNumber.headerName
    },
    {
        value: colContractName,
        viewValue: colContractName.headerName
    },
    {
        value: colAttachmentCreatedDate,
        viewValue: colAttachmentCreatedDate.headerName
    },
    {
        value: colAttachmentDateAdded,
        viewValue: colAttachmentDateAdded.headerName
    }
  ]
